module.exports = __webpack_public_path__ + "img/logo.c4e02e33.jpeg";